import { AccessGuard } from '@/components/layout/access-guard'

export function ProtectedCoachManagerRoute() {
  return (
    <AccessGuard
      routeId="coach-manager.root"
      deniedTitle="Coach Manager access required"
      deniedMessage="This account is valid, but it cannot use the Coach Manager Portal."
    />
  )
}
